import React, { FC } from 'react'

import { IconType } from '../../common/types'

const NucEnvelope: FC<IconType> = ({
  iconColor = 'currentColor',
  ...svgProps
}) => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 18 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...svgProps}
    >
      <path
        d='M16.3125 0.5C17.2266 0.5 18 1.27344 18 2.1875C18 2.75 17.7188 3.24219 17.2969 3.55859L9.66797 9.28906C9.24609 9.60547 8.71875 9.60547 8.29688 9.28906L0.667969 3.55859C0.246094 3.24219 0 2.75 0 2.1875C0 1.27344 0.738281 0.5 1.6875 0.5H16.3125ZM7.62891 10.2031C8.4375 10.8008 9.52734 10.8008 10.3359 10.2031L18 4.4375V11.75C18 13.0156 16.9805 14 15.75 14H2.25C0.984375 14 0 13.0156 0 11.75V4.4375L7.62891 10.2031Z'
        fill={iconColor}
      />
    </svg>
  )
}

export default NucEnvelope
